"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
function StoriesConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div data-section-id="169561" className="flex flex-col gap-6 sm:gap-8">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex animate-pulse flex-col gap-6 rounded-xl border border-border bg-card p-4 md:flex-row md:p-6">
            <div className="aspect-video w-full shrink-0 rounded-lg bg-muted md:w-1/3 md:aspect-[4/3]" />
            <div className="flex flex-1 flex-col justify-center space-y-4 py-2">
              <div className="h-6 w-24 rounded-md bg-muted" />
              <div className="h-8 w-3/4 rounded-md bg-muted" />
              <div className="space-y-2">
                <div className="h-4 w-full rounded-md bg-muted" />
                <div className="h-4 w-5/6 rounded-md bg-muted" />
              </div>
              <div className="mt-4 h-10 w-32 rounded-md bg-muted" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="rounded-xl border border-border bg-card py-12 text-center">
        <p className="mb-4 font-sans text-muted-foreground">
          Unable to retrieve recent updates.
        </p>
        <Button variant="outline" onClick={refetch} className="border-primary text-primary hover:bg-primary/5">
          Try Again
        </Button>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="rounded-xl border border-border bg-card py-12 text-center">
        <p className="font-sans text-muted-foreground">
          No stories available at the moment.
        </p>
      </div>;
  }
  return <div className="flex flex-col gap-6 sm:gap-8">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group relative flex flex-col gap-6 overflow-hidden rounded-xl border border-border/50 bg-card p-4 shadow-sm transition-all duration-500 hover:shadow-xl md:flex-row md:p-6">
          <div className="w-full shrink-0 overflow-hidden rounded-lg md:w-1/3">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602004/img/generic_impact_story.png"} alt={post.title} className="aspect-video h-full w-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105 md:aspect-[4/3]" />
          </div>

          <div className="flex flex-1 flex-col items-start justify-center py-2">
            <Badge variant="secondary" className="mb-4 font-mono text-xs uppercase tracking-wider">
              Impact Update
            </Badge>

            <h3 className="mb-3 text-2xl font-bold leading-tight tracking-tight text-primary md:text-3xl">
              {post.title}
            </h3>

            {post.excerpt && <div className="mb-6 line-clamp-3 font-sans text-base leading-relaxed text-muted-foreground md:text-lg" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}

            <div className="mt-auto w-full opacity-100 transition-opacity duration-300 focus-within:opacity-100 md:w-auto md:opacity-0 md:group-hover:opacity-100">
              <Link to={post.link || "#"} className="inline-block w-full md:w-auto">
                <Button className="group/btn w-full gap-2 bg-primary text-primary-foreground shadow-md hover:bg-primary/90 md:w-auto">
                  Read Full Story
                  <ArrowRight className="h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
                </Button>
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function RealStoriesOfImpact() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}